import { create } from 'zustand';
import type { WalletBalance } from '@hirenfire/shared';
import { Chain } from '@hirenfire/shared';

interface WalletState {
  wallets: WalletBalance[];
  selectedChain: Chain;
  isLoading: boolean;
  setWallets: (wallets: WalletBalance[]) => void;
  setSelectedChain: (chain: Chain) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useWalletStore = create<WalletState>((set) => ({
  wallets: [],
  selectedChain: Chain.POLYGON,
  isLoading: false,

  setWallets: (wallets) =>
    set({ wallets }),

  setSelectedChain: (selectedChain) =>
    set({ selectedChain }),

  setLoading: (isLoading) =>
    set({ isLoading }),

  reset: () =>
    set({ wallets: [], selectedChain: Chain.POLYGON, isLoading: false }),
}));
